var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14021 1 1 4.14021 1 8C1 11.8598 4.14021 15 8 15C11.8598 15 15 11.8598 15 8C15 4.14021 11.8598 1 8 1ZM8 14.2632C4.5464 14.2632 1.73683 11.4536 1.73683 8C1.73683 4.5464 4.5464 1.73683 8 1.73683C11.4536 1.73683 14.2632 4.5464 14.2632 8C14.2632 11.4536 11.4536 14.2632 8 14.2632Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8833 5.11762C10.7154 4.94973 10.4434 4.94973 10.2755 5.11762L5.11762 10.2755C4.94973 10.4434 4.94973 10.7154 5.11762 10.8833C5.20158 10.9673 5.31155 11.0092 5.42151 11.0092C5.53147 11.0092 5.64147 10.9673 5.7254 10.8833L10.8833 5.72543C11.0512 5.5575 11.0512 5.28552 10.8833 5.11762Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57162 5.85197C7.57162 4.90333 6.80013 4.13184 5.85148 4.13184C4.90284 4.13184 4.13135 4.90333 4.13135 5.85197C4.13135 6.80061 4.90284 7.57211 5.85148 7.57211C6.80013 7.57211 7.57162 6.80061 7.57162 5.85197ZM4.99099 5.85197C4.99099 5.37764 5.37715 4.99147 5.85148 4.99147C6.32582 4.99147 6.71198 5.37764 6.71198 5.85197C6.71198 6.32631 6.32582 6.71247 5.85148 6.71247C5.37715 6.71247 4.99099 6.32628 4.99099 5.85197Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 8.42822C9.19972 8.42822 8.42822 9.19972 8.42822 10.1484C8.42822 11.097 9.19972 11.8685 10.1484 11.8685C11.097 11.8685 11.8685 11.097 11.8685 10.1484C11.8685 9.19972 11.097 8.42822 10.1484 8.42822ZM10.1484 11.0089C9.67402 11.0089 9.28786 10.6227 9.28786 10.1484C9.28786 9.67402 9.67402 9.28786 10.1484 9.28786C10.6227 9.28786 11.0089 9.67402 11.0089 10.1484C11.0089 10.6227 10.6227 11.0089 10.1484 11.0089Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.f7eddd8bf087074e9c10b8d246d73b57.svg";
export { ForwardRef as ReactComponent };